<template>
  <Drawer :active="show" @close="$emit('close')">
    <template slot="header">
      <div class="photo-selection__title">
        <slot name="titledrawer">{{$t('lang.elige_fecha.msg')}}</slot>
      </div>
    </template>

    <div class="photo-selection__content">
      <div class="photo-selection__datepicker">
        <VueCtkDateTimePicker
          :class="{'ocultar-menu-calendario': esPublico}"
          inline
          only-date
          format="YYYY-MM-DD"
          :disabled-dates="camera.dates_without_photos"
          :max-date="maxDate"
          :min-date="minDate"
          no-header
          no-button
          no-shortcuts
          no-label
          no-keyboard
          color="var(--primary)"
          :locale="$i18n.locale"
          @input="fetchPhotos"
          :value="formattedDate"
        />
      </div>
      <div class="photo-selection__divider"></div>
      <div class="photo-selection__photos" id="divAbajo">
       
        <div
          class="d-flex justify-content-center align-items-center h-100"
          v-if="!loading && photos.length === 0"
        >
          <span>{{$t('lang.sin_fotos_fecha.msg')}}</span>
        </div>
        <div
          v-else
          :class="{ 'align-items-center justify-content-center': photos.length === 0, 'photo-selection__photos-wrapper': !loading }"
        >
          <b-overlay :show="loading" rounded="sm">
            <br><br><br><br><br><br><br><br><br>
          </b-overlay>
          <div
            :style="loading ? `visibility: hidden;` : ''"
            class="photo-selection__photo"
            :class="{
              'photo-selection__photo--active': value ? value.id === photo.id : false,
            }"
            @click="handleSelectPhoto(photo)"
            v-for="photo in photos"
            :key="photo.id"
          >
            <img loading="lazy" :src="photo.optimized_url" :alt="photo.name" />
            <p class="photo-selection__photo-time">{{ formatCaptureTime(photo.captured_at) }}</p>
            <svg class="photo-selection__photo-check" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import dateUtil from '@/util/date';
import Drawer from '@/components/Drawer';

export default {
  name: 'PhotoSelectorDrawer',
  components: {
    Drawer,
    VueCtkDateTimePicker,
  },

  props: {
    camera: { type: Object, required: true },
    date: { type: Date, default: () => new Date() },
    show: { type: Boolean, default: false },
    closeOnSelectPhoto: { type: Boolean, default: false },
    value: { type: Object },
    mostrarDiaAnterior:{},
    esPublico: { type: Boolean, default: false }
  },

  data() {
    return {
      selectedDate: this.date,
      photos: [],
      tiempoTranscurrido: Date.now(),
      hoy:null,
      loading: true,
    };
  },

  watch: {
    date: {
      immediate: false,
      handler: function(newValue) {
        this.fetchPhotos(newValue);
      },
    },
    mostrarDiaAnterior:{
      immediate: true,
      handler: function(newValue) {
        if(this.mostrarDiaAnterior){
          this.fetchPhotos(this.selectedDate, newValue);
        }
      },
    }
  },
  created() {
    
    this.fetchPhotos(this.date, false, true);
  },
  computed: {
    minDate() {
      return this.camera.first_capture_at
        ? dateUtil.toDateString(new Date(this.camera.first_capture_at))
        : dateUtil.toDateString(new Date());
    },
    maxDate() {
      return this.camera.last_capture_at
        ? dateUtil.toDateString(new Date(this.camera.last_capture_at))
        : dateUtil.toDateString(new Date());
    },
    formattedDate() {
      console.log('dateUtil', dateUtil.toDateString(this.selectedDate));
      return dateUtil.toDateString(this.selectedDate);
    },
  },

  methods: {
    dateDisabled(ymd) {
      return this.datesWithoutPhotos.includes(ymd);
    },
    handleSelectPhoto(photo) {
      this.$emit('input', photo);

      if (this.closeOnSelectPhoto) {
        this.$emit('close');
      }
    },
    formatCaptureTime(date) {
      return new Date(date).toLocaleTimeString(undefined, {
        hour: 'numeric',
        hour12: false,
        minute: 'numeric',
      });
    },
    async fetchPhotos(date, diaAnterior=false, tomaLaHoraCercana = false) {
      //console.log("🚀 fetchPhotos ~ CambiaAlDia", diaAnterior)
      //console.log('fetchPhotos', date);

      let dateObject = date;

      if (!(date instanceof Date)) {
        dateObject = new Date(date + 'T00:00:00');
      }

      if(diaAnterior == 'diaAnterior'){
        dateObject = new Date(dateObject);
        dateObject.setDate(dateObject.getDate() - 1);
      }else if(diaAnterior ==  'diaSiguiente'){
        dateObject = new Date(dateObject);
        dateObject.setDate(dateObject.getDate() + 1);
      }
     
      this.hoy = new Date(this.tiempoTranscurrido);
      //console.log(this.hoy.toLocaleDateString(),"es hoy");
      //console.log(dateObject.toLocaleDateString());
      dateObject.toLocaleDateString() < this.hoy.toLocaleDateString() ? console.log("si es menor a hoy") : 'no es menor';
      this.selectedDate = dateObject;
      this.loading = true;
      this.photos = [];
      //console.log(dateObject,"hora");
      this.photos = await this.$store.dispatch('photo/fetchPhotos', {
        camera: this.camera,
        startDate: dateUtil.startOfDay(dateObject),
        endDate: dateUtil.endOfDay(dateObject),
        page: 1,
        esPublico: this.esPublico
      });
      //console.log("🚀 ~ fetchPhotos ~ this.photos", this.photos)

      if(tomaLaHoraCercana){
        const encontrado = this.photos.filter(x => this.formatCaptureTime(x.captured_at) == this.formatCaptureTime(dateObject))
        //console.log("🚀 ~ file: ~ encontrado", encontrado)
        if(encontrado){
          this.loading = false;
          return this.$emit('input', encontrado[0] ?? null);
        }
        
      }

      
      let posicionMarkSelectFoto=0;
      if(diaAnterior == 'diaSiguiente'){
        posicionMarkSelectFoto = this.photos.length-1;
        await this.sleep(3000);
        this.scrollToElement();
      }
      
      this.$emit('input', this.photos[posicionMarkSelectFoto] ?? null);

      
      this.loading = false;
    },

    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },

    scrollToElement() {

      var container = this.$el.querySelector("#divAbajo");
      container.scrollTop = container.scrollHeight;
    
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';

.photo-selection {
  &__title {
    font-size: 1.5rem;
    font-weight: bold;
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: 0 1rem 0;
    height: 100%;

    @include media-breakpoint-up(md) {
      flex-direction: row;
    }
  }

  &__divider {
    background-color: #c1c1c1;
    display: none;

    @include media-breakpoint-up(md) {
      margin: 0 1rem;
      height: 100%;
      display: block;
      width: 1px;
      flex-shrink: 0;
    }
  }

  &__photos {
    overflow-y: auto;
    margin-top: 1rem;
    padding-bottom: 1rem;
    flex: 1;

    @include media-breakpoint-up(md) {
      margin-top: 0;
    }

    img {
      width: 100%;

      @include media-breakpoint-up(md) {
        height: 100px;
        width: 180px;
      }
    }
  }

  &__photos-wrapper {
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: -0.5rem;
      margin-left: -0.5rem;
    }
  }

  &__photo {
    $self: &;
    margin-bottom: 1.25rem;
    cursor: pointer;
    position: relative;

    @include media-breakpoint-up(md) {
      margin: 0.5rem 0.5rem 0.5rem 0.5rem;
    }

    &--active {
      #{ $self }-check {
        display: block;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__photo-check {
    display: none;
    height: 20x;
    width: 20px;
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    fill: rgba(78, 207, 59, 0.8);
    color: white;
    background-color: white;
    border-radius: 100%;
  }

  &__photo-time {
    font-size: 0.875rem;
    padding-top: 0.25rem;
  }
}
</style>


<style>
.ocultar-menu-calendario .datepicker-controls {
  display: none;
}
</style>